module.exports = __webpack_public_path__ + "media/8558-floating-document.1a5bfd19.mp4";